<h1 mat-dialog-title class="dialog-title">{{ 'FRONTEND.SALES_UI.ADD_ITEMS' | translate }}</h1>
<mat-dialog-content class="sales-order-dialog-content">
  <sales-ui-sales-order-line-item-selector
    [partnerId]="partnerId$ | async"
    [marketId]="marketId"
    [preselectedPackages]="preselectedPackages"
    [preselectedApps]="preselectedApps"
    [hideSellingStandaloneProducts]="hideSellingStandaloneProducts"
    [hidePackages]="hidePackages"
    [hideOwnerName]="hideOwnerName"
    [hideOrderFormProducts]="hideOrderFormProducts"
    [wholesalePricing]="wholesalePricing"
  />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button matDialogClose tabindex="-1" data-testid="line-item-selector-cancel-button">
    {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="selectPackages()">
    {{ 'FRONTEND.SALES_UI.SELECT' | translate }}
  </button>
</mat-dialog-actions>
